export default function whenAvailable(
  name: string,
  callback: (...args: any[]) => void,
) {
  const interval = 10; // ms
  window.setTimeout(function () {
    if ((window as any)[name]) {
      callback((window as any)[name]);
    } else {
      whenAvailable(name, callback);
    }
  }, interval);
}
